// @ts-nocheck
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
	selector: 'lbca-input-hidden',
	templateUrl: './input-hidden.component.html',
})
export class InputHiddenComponent {
	public valueToReturn!: string;
	public labelValue!: string;

	@ViewChild('inputHidden', { static: true }) inputHidden!: ElementRef;

	@Input() set label(value: string) {
		this.labelValue = value;
	}

	@Input()
	set defaultValue(value) {
		this.valueToReturn = value;
		this.inputHidden!.nativeElement.value = value;
	}

	constructor() {}
}
